/**
 * @generated SignedSource<<916ff5056c6d334a10e9ed1ff4c73c56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdMetricFilterField = "AmountSpent" | "CostPerPurchase" | "CostPerWebsitePurchase" | "Impressions" | "LandingPageViews" | "Leads" | "LinkClicks" | "Purchases" | "Rate" | "WebsiteAddToCarts" | "WebsiteLeads" | "WebsitePurchases" | "%future added value";
export type AdPreviewFormat = "INSTAGRAM_STORY" | "MOBILE_FEED_STANDARD" | "%future added value";
export type ContentType = "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type CurrencyType = "CAD" | "EUR" | "USD" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type ListPerformanceSummarizedMetaAdsOrderBy = "KPI_ASC" | "KPI_DESC" | "%future added value";
export type MetricFilterOperator = "EQ" | "GT" | "GTE" | "LT" | "LTE" | "NE" | "%future added value";
export type ListPerformanceSummarizedMetaAdsRequest = {
  config: ListPerformanceSummarizedMetaAdsConfig;
  filter: ListPerformanceSummarizedMetaAdsFilter;
  orderBy?: ListPerformanceSummarizedMetaAdsOrderBy | null;
  pagination?: PaginationInput | null;
};
export type ListPerformanceSummarizedMetaAdsFilter = {
  brandId?: string | null;
  contentTypes?: ReadonlyArray<ContentType> | null;
  deduplicateAdNames?: boolean | null;
  filterOutZero?: boolean | null;
  metrics?: ReadonlyArray<AdMetricFilter> | null;
  performanceDateRange?: DateRangeInput | null;
  searchQueries?: ReadonlyArray<SearchQuery> | null;
};
export type DateRangeInput = {
  end: string;
  start: string;
};
export type SearchQuery = {
  fieldKey: string;
  type: string;
  value: string;
};
export type AdMetricFilter = {
  fieldKey: AdMetricFilterField;
  operator: MetricFilterOperator;
  value: number;
};
export type ListPerformanceSummarizedMetaAdsConfig = {
  kpi: KPI;
  scrubSensitiveData?: boolean | null;
};
export type PaginationInput = {
  skip?: number | null;
  take?: number | null;
};
export type BottomPerformingAdsQuery$variables = {
  adPreviewFormat?: AdPreviewFormat | null;
  input: ListPerformanceSummarizedMetaAdsRequest;
  skip: boolean;
};
export type BottomPerformingAdsQuery$data = {
  readonly listPerformanceSummarizedMetaAds?: {
    readonly count: number;
    readonly data: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AdBlockListItem_PerformanceSummarizedMetaAd" | "AdDetailsModal_PerformanceSummarizedMetaAd">;
    }>;
    readonly metadata: {
      readonly currencyType: CurrencyType | null;
    };
    readonly pageInfo: {
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
  };
};
export type BottomPerformingAdsQuery = {
  response: BottomPerformingAdsQuery$data;
  variables: BottomPerformingAdsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "adPreviewFormat"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PerformanceSummarizedMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencyType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BottomPerformingAdsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "PerformanceSummarizedMetaAdList",
            "kind": "LinkedField",
            "name": "listPerformanceSummarizedMetaAds",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PerformanceSummarizedMetaAd",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AdBlockListItem_PerformanceSummarizedMetaAd"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AdDetailsModal_PerformanceSummarizedMetaAd"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "BottomPerformingAdsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "PerformanceSummarizedMetaAdList",
            "kind": "LinkedField",
            "name": "listPerformanceSummarizedMetaAds",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PerformanceSummarizedMetaAd",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "brandName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountSpent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "format",
                        "variableName": "adPreviewFormat"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "preview",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "websitePurchases",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "websiteAddToCarts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "landingPageViews",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costPerPurchase",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costPerWebsitePurchase",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "websitePurchasesPercentile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "websiteAddToCartsPercentile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costPerPurchasePercentile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "costPerWebsitePurchasePercentile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "purchases",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "purchasesPercentile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "landingPageViewsPercentile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregatedLabels",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3255a8e185bb5fb8b154331a856752d1",
    "id": null,
    "metadata": {},
    "name": "BottomPerformingAdsQuery",
    "operationKind": "query",
    "text": "query BottomPerformingAdsQuery(\n  $input: ListPerformanceSummarizedMetaAdsRequest!\n  $adPreviewFormat: AdPreviewFormat\n  $skip: Boolean!\n) {\n  listPerformanceSummarizedMetaAds(input: $input) @skip(if: $skip) {\n    count\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    metadata {\n      currencyType\n    }\n    data {\n      id\n      ...AdBlockListItem_PerformanceSummarizedMetaAd\n      ...AdDetailsModal_PerformanceSummarizedMetaAd\n    }\n  }\n}\n\nfragment AdBlockListItem_PerformanceSummarizedMetaAd on PerformanceSummarizedMetaAd {\n  id\n  name\n  primaryText\n  externalId\n  brandName\n  rate\n  amountSpent\n  ...FullAdPreview_PerformanceSummarizedMetaAd\n}\n\nfragment AdDetailsModal_PerformanceSummarizedMetaAd on PerformanceSummarizedMetaAd {\n  id\n  name\n  amountSpent\n  websitePurchases\n  websiteAddToCarts\n  landingPageViews\n  costPerPurchase\n  costPerWebsitePurchase\n  websitePurchasesPercentile\n  websiteAddToCartsPercentile\n  costPerPurchasePercentile\n  costPerWebsitePurchasePercentile\n  purchases\n  purchasesPercentile\n  landingPageViewsPercentile\n  aggregatedLabels\n  tags\n}\n\nfragment FullAdPreview_PerformanceSummarizedMetaAd on PerformanceSummarizedMetaAd {\n  id\n  preview(format: $adPreviewFormat)\n}\n"
  }
};
})();

(node as any).hash = "6ead34f1c7882737364d5b1615f64974";

export default node;
